import React from 'react';
import { useCountdown } from '../contexts/CountdownContext';
type CountdownDigitsProps = {
  className?: string;
};
export function CountdownDigits({
  className = ''
}: CountdownDigitsProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <span className={`font-mono font-extrabold tabular-nums tracking-widest ${className}`} data-id="element-66" data-mp="3e450a9v32stw">
      <span aria-hidden="true" data-id="element-67" data-mp="3iz0rx8were6h">
        {hours}
        <span className="animate-blink" data-id="element-68" data-mp="3o0zwun7sqj5j">:</span>
        {minutes}
        <span className="animate-blink" data-id="element-69" data-mp="3nydnci1chtko">:</span>
        {seconds}
      </span>
      <span className="sr-only" data-id="element-70" data-mp="3sxgmjlun95kq">{`${hours} hours ${minutes} minutes ${seconds} seconds remaining`}</span>
    </span>;
}